import cn from 'classnames';
import React, { FC, ReactNode, useEffect, useState } from 'react';
// import { useDispatch } from 'react-redux'
import {
  DropdownList,
  getIcon,
  ILibDropdownItem,
  ILibHorizontalPosition,
  LibIconList,
  Popover,
} from '@infologistics/frontend-libraries';

// import { setInstance } from '@store/modules/utils/actions'

import { Instance, lookupLocalStorage } from '@const/consts';
import { dropdownItems } from './consts';
import { getInstance } from '@utils/utils';

const styles = require('./ButtonInstance.module.css');

const getFlagName = (value: string): LibIconList => {
  const flagNames = {
    [Instance.GLOBAL]: 'IconFlagEn',
    [Instance.ZA]: 'IconFlagZa',
    [Instance.RU]: 'IconFlagRu',
    [Instance.BR]: 'IconFlagBr',
    [Instance.VN]: 'IconFlagVn',
    [Instance.UAE]: 'IconFlagUAE',
  };

  return flagNames[value];
};

const getOptions = (dropdownItems: ILibDropdownItem[]): ILibDropdownItem[] => {
  return dropdownItems.map((val) => ({
    ...val,
    element: (
      <div className='d-flex align-items-center'>
        {getIcon(getFlagName(val.name))}
        <span className='ml-1'>{val.translation}</span>
      </div>
    ),
  }));
};

const ButtonInstance: FC = () => {
  const [popoverOpened, setPopoverOpened] = useState<boolean>(false);
  const [selectedTitle, setSelectedTitle] = useState<LibIconList>('IconFlagEn');

  // const dispatch = useDispatch<any>()
  const instance = (localStorage.getItem(lookupLocalStorage.INSTANCE) as Instance) ?? Instance.GLOBAL;

  useEffect(() => {
    setSelectedTitle(getFlagName(instance));
  }, []);

  const getSelectedItem = (items: ILibDropdownItem[]): ILibDropdownItem | undefined =>
    items.find(({ name }) => name === instance);

  const toggleClose = (isOpenFromPopover: boolean): void => {
    !isOpenFromPopover && setPopoverOpened(false);
  };

  const handleSelect = ({ name }: ILibDropdownItem): void => {
    setSelectedTitle(getFlagName(name));
    setPopoverOpened(false);

    const instance = getInstance(name);
    window.localStorage.setItem(lookupLocalStorage.INSTANCE, instance);
    window.location.reload();
    // dispatch(setInstance(instance))
  };

  const getButton = (): ReactNode => (
    <div onClick={() => setPopoverOpened(!popoverOpened)}>{getIcon(selectedTitle)}</div>
  );

  return (
    <div className={cn(styles.wrapper, 'fixed')}>
      <Popover
        buttonComponent={getButton()}
        withoutArrow
        allowDropdownFlip
        horizontalPosition={ILibHorizontalPosition.RIGHT}
        parentManagement={{
          isOpenFromParent: popoverOpened,
          callbackForClose: toggleClose,
        }}
      >
        <DropdownList
          dropdownItems={getOptions(dropdownItems)}
          onSelect={handleSelect}
          itemClasses='p-2'
          selectedItem={getSelectedItem(dropdownItems)}
        />
      </Popover>
    </div>
  );
};

export default ButtonInstance;
